import apiBase from "./apiBase";

export default function exhibitionsApiRequest(params, onSuccess, onError) {
  const path = "/api/v1/exhibitions";
  return apiBase({ path, params, onSuccess, onError });
}
